module.exports = __webpack_public_path__ + "img/u31.5c0bafb7.png";